import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Gallery from 'react-grid-gallery';
import './grouppage.css';

// tämä funkkari järjestää jsonin aikajärjestykseen
function comp(a, b) {
    return new Date(a.time).getTime() - new Date(b.time).getTime();
}
//-----------------------------------------------------------------------------
// haetaan kamerakohtainen json kuvista, ja lähdetään muuttamaan tilaa
// sitten kun valmis. Kerrotaan montako halutaan.
//  props:
//    labelList={this.state.labelList}
//    appState={this.state.appState}
//    onImageListChange={this.handleImageListChange}
//    placeName={this.state.placeName}
//    imagesAmount={this.state.latestImages}

class GetCams extends Component {
  render() {
    if (this.props.appState ===1){
      // converting the labelList -object into array of objects
      const labelArray = Object.values(this.props.labelList);
      // Get Object length - number of cameras
      var obs=Object.keys(this.props.labelList).length;
      var cams=[];
      for(let i = 0; i<obs; i++){
        //console.log('Array: '+labelArray[i].label);
        cams[i]=labelArray[i].label;
      }
      var g1=this.props.labelList.id1.group;
      var nImg=this.props.imagesAmount;
      var camUrl ='https://hd37kdnllg.execute-api.eu-west-1.amazonaws.com/test/photos?place='+g1
      if(this.props.placeName !==""){
        camUrl = camUrl +"/"+this.props.placeName;
      }
      fetch (camUrl).then((response) => {
          response.json().then((data)=> {
            this.props.onImageListChange(data,nImg);
          }); //response.json
        });	// response
      return (
        <div>
        <p> </p>
        </div>
      );
    } // if
    else {
        return(<p> </p>);
    } //else
  } //render
} // class GetCams

//-----------------------------------------------------------------------------
// Haetaan ryhmän-json kameroista ja lähdetään muuttamaan
// tilaa sitten kun valmis.
//  props:
//    onLabelDataChange={this.handleLabelDataChange}
//    appState={this.state.appState}
//    groupName={this.state.groupName}


class GetJson extends Component {
  render() {
    if (this.props.appState ===0 && this.props.groupName!==""){
      var url='https://hd37kdnllg.execute-api.eu-west-1.amazonaws.com/test/places?dir=' +this.props.groupName +'/';
      fetch(url).then((response) => {
          response.json().then((data)=> {
            this.props.onLabelDataChange(data);
          }); //response.json
        });	// response
        return (
          <p> </p>
        );
      } //if
      else return (<p> </p>);
  } //render
}// class GetJson

//----------------------- GroupPage hoitaa kaiken------------------------------
class GroupPage extends Component {
  constructor(props){
		super(props);
		this.state = {
      groupName: "",
      currentImage:0,
      placeName: "",
      latestImages: "5",
      appState: 0,
      labelList: {},
      imageList: [
        //  pitäisi näyttää tältä
        /*{
              src: "https://s3-eu-west-1.amazonaws.com/kuvassa.si/test/laabeli/20191102111637-image0.jpeg",
              thumbnail: "https://s3-eu-west-1.amazonaws.com/kuvassa.si/test/laabeli/20191102111637-image0.jpeg",
              thumbnailWidth: 320,
              thumbnailHeight: 212,
              isSelected: true,
              tags: [{value: "Pupu", title: "Pupu"}, {value: "testaa", title: "testaa"}],
              caption: "Tähän kuvan nimi"
      }*/
      ]
		};
    this.handleLabelDataChange=this.handleLabelDataChange.bind(this);
    this.handleImageListChange=this.handleImageListChange.bind(this);
    this.handleGroupNameChange=this.handleGroupNameChange.bind(this);
    this.onCurrentImageChange = this.onCurrentImageChange.bind(this);
    this.archiveImage = this.archiveImage.bind(this);
  } // constructor

// -------------  STATE CHANGES ---------------
// tämä triggaa GetJsonista, kun uusi json löytyi
  handleLabelDataChange(data) {
    this.setState({labelList:data, appState:1} );
    console.log('Got group json: '+data.id1.group);
    console.log('appState : 1');
  }
// tämä tilamuutos triggaa, jos url-muuttujat vaihtuivat.
// pitää palauttaa appiksen tila nollaan, jotta saadaan GETit käyntiin.
  handleGroupNameChange(gname,pname,latest){
    console.log("url vars changed: "+gname +" "+pname +" "+latest);
    console.log("appState: 0");
    this.setState({groupName:gname, placeName:pname, latestImages:latest, appState:0});
  }
  handleImageListChange(iList,montako){
    const imageArray = Object.values(iList);
    // Get Object length - number of images
    var images=Object.keys(iList).length;

    //pitääkö date format muuttaa?
    if (imageArray[0].time.slice(2,3) ==="."){
      //pitää
      for (let c=0; c<images; c++){
          var DD=imageArray[c].time.slice(0,2);
          var MM=imageArray[c].time.slice(3,5);
          var YYYY=imageArray[c].time.slice(6,10);
          var HH=imageArray[c].time.slice(11,13);
          var MIN=imageArray[c].time.slice(14,16);
          var SS=imageArray[c].time.slice(17,19);

          var D=YYYY+'-'+MM+'-'+DD+' '+HH+':'+MIN+':'+SS;
          //console.log(new Date(D));
          imageArray[c].time=D;
      } /// for c
    } //if "."
    // Järjestellään json aikajärjestykseen
    imageArray.sort(comp);

    // Tehdään imageArray -konversio
    var tmpList=[];
    var tmpJson='[';
    // montakos kuvaa näytetään?
    var iNum;
    if (images > montako){
      iNum=images-montako;
    }  else iNum=0;
    if (montako===0) {iNum=0}; //jos &latest=0, niin näytetään kaikki kuvat.

    // konvertoidaan saatu json Galleryn ymmärtämään muotoon.
    // tehdään ensin JSON, ja konvertoidaan se object- arrayksi.
    // käännetään järjestys, niin saadaan viimeiseksi tullut kuva näkymään ensimmäisenä.
    for (let i=images-1; i>=iNum; i--){
      tmpJson=tmpJson+'{"src": "'+imageArray[i].url_full+'",';
      tmpJson=tmpJson+'"thumbnail": "'+imageArray[i].url_thumb+'",';
      tmpJson=tmpJson+'"thumbnailCaption": "'+imageArray[i].time+'",';
      tmpJson += '"thumbnailWidth":256,';
      tmpJson += '"thumbnailHeight":192,';
      tmpJson += '"key": "'+imageArray[i].key+'",';
      tmpJson=tmpJson+'"caption": "'+imageArray[i].time+'"},';
      //console.log(i+": "+imageArray[i].time);
    }//for
    //otetaan viimeinen loopissa tehty pilkku pois:
    tmpJson=tmpJson.slice(0,-1);
    tmpJson +=']'; //ja suljetaan array
    tmpList=JSON.parse(tmpJson);

    // tilat kuntoon
    this.setState({imageList: tmpList});
    this.setState({appState:2});
    console.log('appState : 2');
  }

  onCurrentImageChange(index) {
          this.setState({ currentImage: index });
          console.log("currentImage: "+index);
  }
  archiveImage() {
         if (window.confirm(`Are you sure you want to archive image number ${this.state.currentImage}?`)) {
           var aImg = this.state.currentImage;
           const iArray = Object.values(this.state.imageList);
           var aUrl= "https://hd37kdnllg.execute-api.eu-west-1.amazonaws.com/test/archive?Key=" +iArray[aImg].key;
           console.log("Archive URL: "+aUrl);


        fetch(aUrl).then((response) => {
            console.log('Got archive response.');
            this.setState({appState:0})
          });	// response
                
      } //if window.confirm
  } //archiveImage

//-------------------------- GroupPage / render -------------------------------
  render() {
    // selvitellään url-muuttujien arvot.
    const search = this.props.location.search;
    const idparams = new URLSearchParams(search);
    var gid = idparams.get('id');
    var pid= idparams.get('place');
    var latest=idparams.get('latest'); //str
    var numLatest = Number(latest); //varmistetaan että se on nummero

    if(pid === null ){
      pid="";
    }
    if(latest === null){ // null -> sitä ei ole urlissa?
      numLatest =20;    //DEFAULT, jos &latest -arvoa ei ole asetettu
    }
    var lIma=this.state.latestImages;
    var gName=this.state.groupName;
    var pName=this.state.placeName;
    // onko joku muuttunut?
    if (gName !== gid || pName !== pid || lIma !== numLatest){
      this.handleGroupNameChange(gid,pid,numLatest); //tämä on huono...
    }
    // luodaan navigaatio, jossa linkit kameroihin
    const labelArray = Object.values(this.state.labelList); //tehdään array
    var obs=Object.keys(this.state.labelList).length; // hajetaan pittuus
    var cams=[];
    var camLinks=[];
    const camObjsArray=[];
    for(let i = 0; i<obs; i++){
      cams[i]=labelArray[i].label ;
      camLinks[i]="/group?id="+this.state.groupName+"&place="+labelArray[i].label;
      camObjsArray[i]={url: camLinks[i], name: cams[i]}; //pikku kikka
    }
    // ja nythän se jo onnistuu .mapilla
    const listItems = camObjsArray.map((camObjsArray,cams) =>
        <div key={camObjsArray.name}>
        <Link to={camObjsArray.url}>{camObjsArray.name}</Link>
        </div>
    );
    var gUrl="/group?id="+this.state.groupName;
    // ----- GroupPage / return -----
    return (
      <div  className="GroupPage">

        <div className="flexbox-container">
          <b> <Link to={gUrl}>{gName}</Link>/{pName}</b> {listItems}
        </div>

          <GetJson
            onLabelDataChange={this.handleLabelDataChange}
            appState={this.state.appState}
            groupName={this.state.groupName}
            />

          <GetCams
            labelList={this.state.labelList}
            appState={this.state.appState}
            onImageListChange={this.handleImageListChange}
            placeName={this.state.placeName}
            imagesAmount={this.state.latestImages}
          />

        <Gallery
          images={this.state.imageList}
          enableLightbox={true}
          enableImageSelection={false}
          currentImageWillChange={this.onCurrentImageChange}
          customControls={[
            <button key="archiveImage" onClick={this.archiveImage}>Archive</button>
            ]}
          />
      </div>

    );
  }
}
export default GroupPage;



// WEBPACK FOOTER //
// ./src/grouppage.js